module.exports = __webpack_public_path__ + "ortved_round-a169f2dd63beaa3d30fc443222d13457.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/ortved_round.jpg
// module id = 1167
// module chunks = 1 2